import React, { useContext } from "react";
import InputCustom from "../../../../../../components/Input";
import { FormikErrors, FormikTouched, FormikValues, getIn } from "formik";
import Label from "../../../../../../components/Label";
import DropdownCustom from "../../../../../../components/DropdownCustom";
import VoucherCurrency from "./VoucherCurrency";
import {
  FormikHandleChangeTye,
  FormikSetFieldValueType,
} from "../../../../configs/DeclareTypes";
import { CampaignCreateEditContext } from "../../../../reducers/CampaignCreateEditContext";

const VoucherPeriod = () => {
  const { errors, touched, isSubmitting, handleChange, setFieldValue, values } =
    useContext(CampaignCreateEditContext);

  return (
    <div className={"campaign-create-type"}>
      <InputCustom
        label={"Percentage discount"}
        labelRequired
        value={values.voucher_reward.value}
        name={"voucher_reward.value"}
        onChange={handleChange}
        error={getIn(errors, "voucher_reward.value")}
        touched={getIn(touched, "voucher_reward.value")}
        disabled={isSubmitting}
      />
      <VoucherCurrency />
      <InputCustom
        labelRequired
        label={"Discount valid for X days from the date a user redeems it"}
        value={values.voucher_reward.redeem_duration}
        name={"voucher_reward.redeem_duration"}
        onChange={handleChange}
        error={getIn(errors, "voucher_reward.redeem_duration")}
        touched={getIn(touched, "voucher_reward.redeem_duration")}
        disabled={isSubmitting}
      />
      <InputCustom
        label={"Maximum redeem value (optional)"}
        labelGuide={
          "Let's say you have a % discount voucher, and you want to give a 50% discount, up to 5 SGD. To do so you put here 5 (SGD) that would limit the total value of the % voucher."
        }
        value={values.voucher_reward.percentage_max_redeem_value}
        name={"voucher_reward.percentage_max_redeem_value"}
        onChange={handleChange}
        error={getIn(errors, "voucher_reward.percentage_max_redeem_value")}
        touched={getIn(touched, "voucher_reward.percentage_max_redeem_value")}
        disabled={isSubmitting}
        removeLetter
      />
    </div>
  );
};

export default VoucherPeriod;
